<template>
    <div class="animated fadeIn">
        <DynamicCardList
                :requestOptions="dataOptions"
                :retrieveOnMount="false"
                ref="dynamicCardListBinderPDF"
                @onRetrieve="binderPDFOnRetrieveList"
                class="mt-2"
                :caption="Core.Definition.getDefinition('PDF générés')"
                :actions="dataDynamicCardListBinderPDF.actions"
                :searchFormStructure="dataDynamicCardListBinderPDF.searchFormStructure"
                :columns="dataDynamicCardListBinderPDF.columns"
                root="/binder-pdf/list">
            <slot slot="cardTableHeaderActions">
                <b-link @click="binderPDFOnClickAdd"  href="#" class="card-header-action btn-setting">
                    <i class="fa fa-plus"></i>&nbsp;{{Core.Definition.getDefinition('PDF')}}
                </b-link>
            </slot>
        </DynamicCardList>

        <ModalTrash
                ref="trash"
                root="/binder-pdf"
                @onTrashSuccess="onTrashSuccess"
                :caption="Core.Definition.getDefinition('Suppression du PDF')"
                :message="Core.Definition.getDefinition('Êtes-vous sûr de vouloir supprimer ce PDF?')"></ModalTrash>

        <ModalBinderPDF
            ref="modalBinderPDF"
            @onSaveSuccess="binderPDFOnSaveSuccess">
        </ModalBinderPDF>

        <ModalPDFView
                ref="modalPDFView">
        </ModalPDFView>

        <Request
                ref="binderGen"
                root="/cron/binder-pdf">
        </Request>

    </div>
</template>

<style>
    .pdf-block .the-block-block {
        display:none!important;
    }
</style>

<script>
    import DynamicCardList from '../../../components/DynamicCardList'
    import ModalTrash from '../../../components/ModalTrash'
    import ModalBinderPDF from '../../../components/ModalBinderPDF'
    import ModalPDFView from '../../../components/ModalPDFView'
    import Request from '../../../components/Request'

    export default {
        name: 'BinderPDF',
        components: {
            Request,
            DynamicCardList,
            ModalTrash,
            ModalBinderPDF,
            ModalPDFView
        },
        props: {
            binderId: {
                type: Number | String,
                default: ''
            }
        },
        watch: {
        },
        mounted() {
            if (Core.Validation.isId(this.$route.params.id)) {
                this.dataBinderId = this.$route.params.id
            } else {
                if (Core.Validation.isId(this.binderId)) {
                    this.dataBinderId = this.binderId
                }
            }
        },
        data: function () {
            return {
                dataOptions: {
                    showAlert: false,
                    blockOnProcessing: false,
                    blockTransparent: false,
                    blockImg: '',
                    blockSpinner: ''
                },
                Core: window.Core,
                dataSlug: '',
                dataBinderId: '',
                dataBinder: {},
                dataTimer: null,
                dataTimerGen: null,
                dataBinderIndex: false,
                dataDynamicCardListBinderPDF: {
                    actions: [
                        {
                            key: 'view',
                            columnLabel: '',
                            columnClasses: '',
                            columnStyles: 'width:20px',
                            value: '<button class="btn btn-sm btn-light"><i class="fa fa-file-pdf-o"></i></button>',
                            callBack: this.binderPDFOnClickView
                        },
                        {
                            key: 'trash',
                            columnLabel: '',
                            columnClasses: '',
                            columnStyles: 'width:20px',
                            value: '<button class="btn btn-sm btn-danger"><i class="fa fa-trash-o"></i></button>',
                            callBack: this.binderPDFOnClickTrash
                        }
                    ],
                    searchFormStructure: {
                        rows: [
                            {
                                cols: [
                                    {
                                        fields: [
                                            {
                                                id: 'title'
                                            }
                                        ]
                                    }
                                ]
                            }
                        ],
                        fields: [
                            {
                                id: 'title',
                                type: 'text',
                                label: Core.Definition.getDefinition('Titre'),
                                value: ''
                            }
                        ]
                    },
                    columns: [
                        {
                            label: Core.Definition.getDefinition('Titre'),
                            key: 'title',
                            sortable: true
                        },
                        {
                            label: Core.Definition.getDefinition('Date de création'),
                            key: 'creationDate',
                            type: 'dateTime',
                            sortable: true
                        },
                        {
                            label: Core.Definition.getDefinition('État'),
                            key: 'status',
                            type: 'select',
                            sortable: true
                        }
                    ]
                }
            }
        },
        beforeDestroy() {
            clearTimeout(this.dataTimerGen)
            clearTimeout(this.dataTimer)
        },
        methods: {
            clear() {
                clearTimeout(this.dataTimerGen)
                clearTimeout(this.dataTimer)
            },
            init() {
                this.autoRefresh()
                this.autoGen()
            },
            autoGen() {
                var _self = this
                clearTimeout(this.dataTimerGen)
                this.dataTimerGen = setTimeout(function(){
                    _self.$refs.binderGen.request()
                    _self.autoGen()
                }, 2000);
            },
            autoRefresh() {
                this.binderPDFOnRetrieveList()
                var _self = this
                clearTimeout(this.dataTimer)
                this.dataTimer = setTimeout(function(){
                    _self.autoRefresh()
                }, 5000);
            },
            binderPDFOnClickAdd() {
                this.$refs.modalBinderPDF.binderId = this.dataBinderId
                this.$refs.modalBinderPDF.open = true
            },
            binderPDFOnClickView(value, cell, row) {
                this.$refs.modalPDFView.documentUrl = row.documentUrl
                this.$refs.modalPDFView.open = true
            },
            binderPDFOnClickTrash(value, cell, row) {
                this.$refs.trash.open(row.id)
            },
            binderPDFOnRetrieveList() {
                this.$refs.dynamicCardListBinderPDF.$refs.request.addArg('binderId', this.dataBinderId)
                this.$refs.dynamicCardListBinderPDF.$refs.request.request()
            },
            binderPDFOnSaveSuccess() {
                this.$refs.modalBinderPDF.open = false
                this.binderPDFOnRetrieveList()
            },
            onTrashSuccess() {
                this.$refs.dynamicCardListBinderPDF.retrieve()
            }
        }
    }
</script>
